import Image from 'next/image';
import Features from '@components/Features';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { CDN2 } from '@/helpers/api';
import { GetServerSideProps } from 'next';
import { basicPageProps } from '@/utils/isServer';
import { Avatar } from 'antd';

const ContentHeader = dynamic(() => import('@components/ContentHeader'), {
  loading: () => <p>Loading</p>,
});

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { airports } = await basicPageProps(ctx);

  return {
    props: {
      airports,
    },
  };
};

function About() {
  return (
    <>
      <Head>
        <title>
          Why On Air Parking? | Quality &amp; Lowest Price Airport Parking
          Guarantee
        </title>
        <meta
          name="description"
          content="We exclusively choose only the best airport parking providers, shuttle service to and from the airport and a guaranteed parking space. Our Parking Reservation Specialist is at your service from 10am-7pm  ET."
        />
      </Head>
      <ContentHeader btitle="About us" />
      <div
        className="w-full -mt-8"
        style={{ backgroundColor: 'rgba(81, 83, 86, 0.03)' }}
      >
        <div className="container px-4 mx-auto">
          <div className="h-auto flex flex-col md:flex-row p-2 md:p-8 my-8 mx-2 place-content-start md:place-content-center gap-0 md:gap-20">
            <div className="text-base md:text-xl mt-12 md:mt-0">
              <p className="text-2xl md:text-3xl">Our Story</p>
              <p className="mt-10 md:mt-6">
                On Air Parking is a product of NOSON, Inc. and was founded in
                2016. NOSON in old Hebrew means "to give", and we believe giving
                is the most powerful way to live. We created On Air Parking on
                the foundation of win-win relationships. We want to give our
                travelers the best experience possible so that they not only
                enjoy their travels, but tell their friends about our service.
                With our partners we make sure we can add the kind of volume
                they are looking for, while still looking out for their bottom
                line! Whoever you are and for whatever reason you are visiting
                our website, it's our mission to make sure we're giving you
                exactly what you're looking for!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="h-32">
        <div className="text-2xl h-full flex flex-col items-center justify-center space-y-2 md:space-y-8 md:text-3xl">
          Team
        </div>
      </div>
      <div className="container mx-auto px-4 mb-0 border-b pb-12">
        <div className="h-auto grid grid-cols-1 lg:grid-cols-2 y-0 pr-0 md:my-8">
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
              src={CDN2() + '/staticmyapp/partnerus/carlos.webp'}
              alt="Carlos Chilin"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6 rounded-full"
            />

            <div className="flex flex-col w-full justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Carlos Chilin</div>
              <div className="text-xl text-center md:text-start">CEO</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
                Carlos is a seasoned airport parking and growth executive with deep expertise in digital marketing, ecommerce, and operations, known for driving customer- and partner-focused strategies that build long-term, sustainable businesses. He brings a proven track record of building high-performing teams and optimizing acquisition channels to deliver exceptional traveler experiences and strong facility partnerships.
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
              src={CDN2() + '/staticmyapp/Adir.png'}
              alt="Adir Filho"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6 rounded-full"
            />

            <div className="flex flex-col w-full  justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Adir Filho</div>
              <div className="text-xl text-center md:text-start">CTO</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
                CTO with over 20 years of experience in game development and
                innovation, leading high-performance teams. Proven track record
                at the helm of significant technology companies, driving
                strategic transformations and creating impactful solutions.
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
                src={CDN2() + '/staticmyapp/Aija.webp'}
                alt="Aija Christopher"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6 rounded-full"
            />

            <div className="flex flex-col w-full  justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Aija Christopher</div>
              <div className="text-xl text-center md:text-start">Director of Customer Experience & Communications</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
                Aija combines creativity, strong communication, and a talent for
                building lasting relationships to drive growth and ensure both
                customer and partner success.
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
                src={CDN2() + '/staticmyapp/Philip.webp'}
                alt="Aija Christopher"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6 rounded-full"
            />

            <div className="flex flex-col w-full  justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Philip Rodriguez</div>
              <div className="text-xl text-center md:text-start">Director of Partnerships</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
               Philip Rodriguez serves as Director of Partnerships at On Air Parking, where he leads the growth and management of relationships with parking and hotel partners across our network. With deep experience in airport parking, airport hotels, and digital marketing, Philip plays a key role in expanding our markets and strengthening our platform offerings.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-32">
        <div className="text-2xl h-full flex flex-col items-center justify-center space-y-2 md:space-y-8 md:text-3xl">
          Founders
        </div>
      </div>
      <div className="container mx-auto px-4 mb-0 border-b pb-12">
        <div className="h-auto grid grid-cols-1 lg:grid-cols-2 y-0 pr-0 md:my-8">
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
              src={CDN2() + '/staticmyapp/patrick.svg'}
              alt="Patrick Murray"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6"
            />

            <div className="flex flex-col w-full justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Patrick Murray</div>
              <div className="text-xl">Chairman, Co-Founder</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
                Named to the National Parking Association's 40 Under 40 list,
                Patrick founded numerous successful startup companies.
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2 mt-8 md:mt-0 mb-8 justify-items-center">
            <Image
              src={CDN2() + '/staticmyapp/brett.svg'}
              alt="Brett Hardwood"
              width={200}
              height={200}
              quality={100}
              className="md:ml-6"
            />

            <div className="flex flex-col w-full  justify-center items-center md:justify-start md:items-start mt-4 md:mt-0">
              <div className="text-3xl">Brett Harwood</div>
              <div className="text-xl">Chief Strategy Officer, Co-Founder</div>
              <div className="text-base mt-3 text-center md:text-left px-8 md:px-0">
                Brett was President of the public parking company Square
                Industries and holds significant industry investments.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-32 mt-8">
        <div className="h-full flex flex-col items-center justify-center space-y-8 text-3xl">
          On Air Parking
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="container px-4 mx-auto max-w-3xl">
          <div className="grid md:grid-cols-2 gap-8 py-8">
            <div className="flex flex-row items-start">
              <Image
                alt="Star"
                src={CDN2() + '/staticmyapp/star-bot.svg'}
                width={150}
                height={150}
              />
              <p className="text-base ml-6">
                Our company partners with <strong>four and five-star</strong>{' '}
                facilities near the airport to provide travelers with the{' '}
                <strong>cheapest rates</strong> for near airport parking.
              </p>
            </div>
            <div className="flex flex-row items-start">
              <Image
                alt="Star"
                src={CDN2() + '/staticmyapp/shield-bot.svg'}
                width={150}
                height={150}
              />
              <p className="text-base ml-6">
                Always <strong>A+</strong> on <strong>quality</strong>,{' '}
                <strong>price</strong>, and <strong>service</strong>, we're on a
                mission to disrupt the airport parking vertical and make parking
                ridiculously cheap and simple every time.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-8 md:py-8">
            <div className="flex flex-row items-start">
              <Image
                alt="Star"
                src={CDN2() + '/staticmyapp/time-bot.svg'}
                width={150}
                height={150}
              />
              <p className="text-base ml-3">
                Most of our facilities have free shuttles on a{' '}
                <strong>frequent schedule</strong> for easy access to and from
                the airport.
              </p>
            </div>
            <div className="flex flex-row items-start">
              <Image
                alt="Star"
                src={CDN2() + '/staticmyapp/alarm-bot.svg'}
                width={150}
                height={150}
              />
              <p className="text-base ml-6">
                Each reservation comes with our{' '}
                <strong>Free Cancellation policy</strong>. Cancel your booking
                before your check in date and you'll receive a full refund, no
                questions asked.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Features showCtaButton={false} />
    </>
  );
}

export default About;
